import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { ToastContext, LoginResponseContext } from '../App';

const LoginPage: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const { showToast } = React.useContext(ToastContext);
  const { setLoginResponse } = React.useContext(LoginResponseContext);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    const result = await login(email, password);
    
    if (result.success) {
      showToast('Login efetuado com sucesso!', 'success');
      // Passar a resposta do login para o App
      setLoginResponse({ showChangelog: result.showChangelog });
      // Aguardar um pouco para garantir que o estado foi atualizado
      setTimeout(() => {
        navigate('/');
      }, 100);
    } else {
      setError(result.message || 'Erro no login');
      showToast(result.message || 'Erro no login', 'error');
    }
    
    setLoading(false);
  };

  return (
    <div className="container py-4">
      <div className="row justify-content-center">
        <div className="col-md-6 col-lg-4">
          <div className="card shadow">
            <div className="card-header" style={{backgroundColor: '#a2449c'}}>
              <h4 className="mb-0 text-white text-center">
                <i className="fas fa-sign-in-alt me-2"></i>
                Entrar
              </h4>
            </div>
            <div className="card-body">
              {/* Removido bloco de erro direto, manter apenas Toast */}

              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label htmlFor="email" className="form-label">Email</label>
                  <input
                    type="email"
                    className="form-control"
                    id="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="password" className="form-label">Password</label>
                  <div className="input-group">
                    <input
                      type={showPassword ? "text" : "password"}
                      className="form-control"
                      id="password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                    />
                    <button
                      className="btn btn-outline-secondary"
                      type="button"
                      tabIndex={-1}
                      onClick={() => setShowPassword((v) => !v)}
                      title={showPassword ? 'Esconder password' : 'Ver password'}
                    >
                      <i className={`fas fa-${showPassword ? 'eye-slash' : 'eye'}`}></i>
                    </button>
                  </div>
                </div>
                <button
                  type="submit"
                  className="btn w-100"
                  style={{backgroundColor: '#a2449c', borderColor: '#a2449c', color: 'white'}}
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                      A entrar...
                    </>
                  ) : (
                    <>
                      <i className="fas fa-sign-in-alt me-2"></i>
                      Entrar
                    </>
                  )}
                </button>
              </form>

              <div className="text-center mt-3">
                <p className="mb-0">
                  Não tem conta?{' '}
                  <Link to="/register" className="text-decoration-none" style={{color: '#a2449c'}}>
                    Registar-se
                  </Link>
                </p>
                <p className="mb-0 mt-2">
                  <Link to="/forgot-password" className="text-decoration-none" style={{color: '#a2449c'}}>
                    <i className="fas fa-question-circle me-1"></i>Esqueci-me da senha
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage; 